<template>
  <div class="cus_select" @blur="open = false" v-click-outside="clickOutSide">
    <!--the case has icon in front of the placeholder-->
    <slot></slot>
    <div
      class="selected jtf_between"
      :tabindex="tabindex"
      :class="{ open: open, disabled: isDisabled, noCursor: isReadonly, disabledConfirm: isDisabledConfirm }"
      @click="handleShowDropDown"
    >
      <!--isReadonly la true. hoac la placeholder-->
      <div v-if="!selected?.img_src" :class="isPlaceholder ? 'placeholder_select' : 'item_choose'">
        {{ selected?.label || selected }}
      </div>
      <!-- case has img in option -->
      <div v-else-if="selected?.img_src">
        <img v-bind:src="require('@/assets/images/' + selected.img_src)" :alt="selected.img_src"/>
        {{ selected.value }}
      </div>
      <span>
        <img class="select_icon" v-if="!isReadonly"
             :src="require('@/assets/images/' + (isDisabled ? 'select_disable.svg' : 'select.svg') )"
             alt="icon"/>
        <img class="select_icon" v-if="isShowIcon" src="@/assets/images/select.svg" alt="icon"/>
      </span>
    </div>
    <div v-if="!isDisabled" class="items" :class="{ selectHide: !open }">
      <div
        class="item"
        :class="isPlaceholder ? 'highlight' : ''"
        @click="clickOptionBlank()"
        v-if="!isReadonly"
      ></div>
      <div
        class="item"
        v-for="(option, i) of options"
        :key="i"
        :class="i === checkValue ? 'highlight' : ''"
        @click="selectOption(i, option)"
      >
        <div
          class="mix-option"
          v-if="option?.img_src"
          @mouseover="option.isShow = true"
          @mouseout="option.isShow = false"
        >
          <img
            v-if="option.isShow"
            v-bind:src="require('@/assets/images/' + option.img_src_hover)"
            :alt="'hover'"
          />
          <img
            v-if="!option.isShow"
            v-bind:src="require('@/assets/images/' + option.img_src)"
            :alt="'no hover'"
          />
          {{ option.value }}
        </div>
        <div v-else>
          {{ option?.label || option }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => [],
      description: ' [{ label: \'??\', value: \'??\' }] ',
    },
    default: {
      type: [String, Object],
      default: null,
    },
    defaultOption: {
      type: [String, Object],
      default: null,
    },
    tabindex: {
      type: Number,
      default: 0,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    isShowIcon: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isDisabledConfirm: {
      type: Boolean,
      default: false,
    },
    placeholderValue: {
      type: String,
      default: '選択してください',
    },
    mix_option: {
      type: Array,
    },
    defaultCheckValue: {
      default: null,
    },
    isReset: {
      type: Boolean,
    },
  },
  data() {
    return {
      selected: null,
      checkValue: this.defaultCheckValue,
      open: false,
      isPlaceholder: this.isReadonly || this.default ? null : 'Yes',
      selected_item: null,
    };
  },
  watch: {
    default(value) {
      this.selected = value || this.placeholderValue;
      this.isPlaceholder = !value;
      this.checkValue = this.options.findIndex((opt) => String(opt?.label) === String(value?.label));
    },
    defaultOption(value) {
      this.checkValue = this.options.findIndex((opt) => String(opt) === String(value));
    },
  },
  created() {
    if (this.defaultOption) {
      this.checkValue = this.options.findIndex((opt) => String(opt) === String(this.defaultOption));
    }
    if (this.default) {
      this.selected = this.default;
    } else if (this.isReadonly) {
      if (this.options.length > 0) {
        this.selected = this.options ?? this.options[0];
      }
      this.selected = '';
    } else {
      this.selected = this.placeholderValue;
    }
  },
  mounted() {
    this.$watch('isReset', () => {
      if (this.isReset === true) {
        this.selected = this.placeholderValue;
        this.checkValue = null;
        this.isPlaceholder = true;
        this.open = false;
        this.$emit('onSelectItem', null);
        this.$emit('onSelectItemIndex', null);
        this.$emit('handleSelectItem');
      }
    });
    this.$emit('input', this.selected);
  },
  methods: {
    clickOutSide() {
      this.open = false;
    },
    handleShowDropDown() {
      if (this.isDisabled) {
        return;
      }
      if (this.defaultOption) {
        this.checkValue = this.options.findIndex(
          (opt) => String(opt) === String(this.defaultOption),
        );
      }
      if (this.default?.label) {
        this.checkValue = this.options.findIndex(
          (opt) => String(opt?.label) === String(this.default?.label),
        );
      }
      this.open = !this.open;
    },
    selectOption(i, option) {
      this.selected = option;
      this.checkValue = i;
      this.open = false;
      this.isPlaceholder = false;
      this.$emit('onSelectItem', option);
      this.$emit('onSelectItemIndex', i);
      this.$emit('handleSelectItem');
    },
    clickOptionBlank() {
      this.selected = this.placeholderValue;
      this.checkValue = null;
      this.isPlaceholder = true;
      this.open = false;
      this.$emit('onSelectItem', null);
      this.$emit('onSelectItemIndex', null);
      this.$emit('handleSelectItem');
    },
  },
};
</script>
